import {
  FaChevronDown,
  FaChevronUp,
  FaPlay,
  FaStopCircle,
} from "react-icons/fa";
import "./Start.css";
import React, { useState, useEffect, useRef } from "react";
import firebase from "firebase/compat/app";
import PuffLoader from "react-spinners/PuffLoader";
import { setAction } from "./setAction";
import { listenResult } from "./listenResult";
import { updateInit } from "./updateInit";
import infoLogo from "../../assets/Info.svg";
import historiqueLogo from "../../assets/Historique.svg";
import { getCurrentUser } from "../../auth/getCurrentUser";
import useGetUserClientType from "../../auth/getUserClientType";
import { useTranslation } from "react-i18next";
import { Collapse } from "react-collapse";
import { startSession } from "./startSession";
import { useComputerData } from "../../context/ComputerDataContext";
import SessionDetailsModal from "./SessionDetailsModal";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

function Start1({
  id,
  ip,
  nom,
  choix_modele,
  clientUid,
  handleResultReleve,
  handleResultStart,
  handleErrorElectron,
  handleAdditionalData,
  setAfficherAddData,
  setAfficherErreur,
  setAfficherReleve,
  computerId,
  handleCopieurId,
}) {
  // Public Sessions
  const { computerData } = useComputerData();

  const foundItem = computerData.find((item) => item.id === computerId);

  const [sessionActions, setSessionActions] = useState(
    ["started", "paused"].includes(foundItem?.public_session?.status)
  );
  const [sessionStartPending, setSessionStardPending] = useState(false);
  const [modeKiosk, setModeKiosk] = useState(foundItem?.kiosk);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [sessionStatus, setSessionStatus] = useState(
    foundItem?.public_session?.status
  );
  const [isPaused, setIsPaused] = useState(
    foundItem?.public_session?.status === "paused"
  );
  const [showSessionModal, setShowSessionModal] = useState(false);
  const [pcStatus, setPcStatus] = useState(foundItem?.pc_status);
  const [pcConfigStatus, setPcConfigStatus] = useState(foundItem?.status);

  const [resultOnReactApp, setResultOnReactApp] = useState([]);
  const [resultCouleur, setResultCouleur] = useState(null);
  const [resultNb, setResultNb] = useState(null);
  const [resultScan, setResultScan] = useState(null);
  const [resultAddData, setResultAddData] = useState(null);
  const [resultDebut, setResultDebut] = useState("");
  const [resultFin, setResultFin] = useState("");
  const [resultDuree, setResultDuree] = useState("");
  const [resultEtat, setResultEtat] = useState(null);
  const [usageDefault, setUsageDefault] = useState(null);
  const [spinner, setSpinner] = useState(false);
  const [spinner2, setSpinner2] = useState(false);
  const [etatLibre, setEtatLibre] = useState(null);
  const [ipLocale, setIpLocale] = useState("");
  const [electronEtat, setElectronEtat] = useState("");
  const [idCopieur, setIdCopieur] = useState("");
  const [copieurActivated, setCopieurActivated] = useState(true);

  const initialize = useRef(true);
  const currentUser = getCurrentUser();
  const userClientType = useGetUserClientType(clientUid);
  const { t } = useTranslation();

  // Function to format date with user's timezone
  const formatDateWithTimezone = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString); // Déjà en format ISO UTC
      const options = {
        dateStyle: "short",
        timeStyle: "short",
        timeZone:
          currentUser?.timezone ||
          Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      return new Intl.DateTimeFormat(undefined, options).format(date);
    } catch (error) {
      console.error("Error formatting date:", error);
      return dateString;
    }
  };

  const urlParams = new URLSearchParams(window.location.search);
  const debug = urlParams.get("debug");

  // initialiser les données initiales
  useEffect(() => {
    if (debug === "true")
      console.log("Initialisation du copieur ", id, " - ", Date.now());
    // console.log('Initialisation du copieur ', id, ' - ', Date.now());

    const initCopieur = async () => {
      setIdCopieur(id);
      const resultInit = await updateInit(id, clientUid);
      initialize.current = true;
      setIpLocale(resultInit.ipInit);
      setUsageDefault(resultInit.usageDefault); //Get the usage_default (libre-service OR main-doeuvre) from resultInit.usageDefault

      if (debug === "true") console.log("resultInit", resultInit);
      // console.log("resultInit", resultInit)
      if (resultInit.error === "no") {
        if (resultInit.etatLibre === "busy") {
          setResultEtat(false);
          setEtatLibre(false);

          setResultDebut(resultInit.dataInit.result_net.data.DateStart);
        } else if (
          resultInit.etatLibre === "free" &&
          resultInit.dataInit.result_net.data &&
          resultInit.dataInit.result_net.data !== ""
        ) {
          setResultEtat(true);
          setEtatLibre(true);
          setResultCouleur(
            resultInit.dataInit.result_net.data.TotalCouleurRealise
          );
          setResultNb(resultInit.dataInit.result_net.data.TotalNbRealise);
          setResultScan(resultInit.dataInit.result_net.data.TotalScanRealise);
          setResultAddData(resultInit.dataInit.result_net.data.additional_data);
          setResultDebut(resultInit.dataInit.result_net.data.DateStart);
          setResultDuree(resultInit.dataInit.result_net.data.Duree);
          setResultFin(resultInit.dataInit.result_net.data.DateEnd);
        } else if (
          resultInit.etatLibre === "free" &&
          !resultInit.dataInit.result_net.data
        ) {
          setResultEtat(true);
          setEtatLibre(true);
        }
      }

      // A la création d'un copieur depuis simply-copy.com => l'état est par défaut vide "" (pas free ou busy)
      if (resultInit.etatLibre === "") {
        setResultEtat(true);
        setEtatLibre(true);
      }

      // Si le copieur a été desactivé par l'utilisateur, on "grise" le bouton start
      if (resultInit.dataInit.activated === false) {
        setCopieurActivated(false);
      }
    };

    initCopieur();
  }, []);

  // Ecoute en temps réel du champ kiosk (et statut session si présent) sur public_computers/{macAdress}
  useEffect(() => {
    if (!clientUid || !computerId) return;

    const unsubscribe = firebase
      .firestore()
      .collection("customers")
      .doc(clientUid)
      .collection("public_computers")
      .doc(computerId)
      .onSnapshot(
        (doc) => {
          const data = doc.data();
          if (!data) return;

          console.log("DATA", data);

          if (typeof data.kiosk === "boolean") {
            setModeKiosk(data.kiosk);
          }

          if (data.public_session && data.public_session.status) {
            const status = data.public_session.status;
            setSessionStatus(status);
            const actionsActive = ["started", "paused"].includes(status);
            setSessionActions(actionsActive);
            setIsPaused(status === "paused");
            setSessionStardPending(false);
          }

          if (typeof data.pc_status === "string") {
            setPcStatus(data.pc_status);
          }

          if (typeof data.status === "string") {
            setPcConfigStatus(data.status);
          }
        },
        (error) => {
          console.error("Erreur lors de l'écoute du mode kiosk:", error);
        }
      );

    return () => unsubscribe();
  }, [clientUid, computerId]);

  // fonction executee qd on clique sur start
  const updateFirebase_start = async () => {
    if (debug === "true")
      console.log("Printer ", id, " - start(début) - ", Date.now());

    // spinner AVANT tout appel réseau
    setSpinner(true);

    if (computerId && sessionStatus === "started") {
      const confirmRestart = window.confirm(
        "Attention, une session SimplyKiosk est déjà lancée, êtes-vous sûr de vouloir écraser cette dernière ?"
      );
      if (!confirmRestart) {
        setSpinner(false); // rollback si l’utilisateur annule
        return;
      }
    }

    await setAction(
      nom,
      id,
      ip,
      choix_modele,
      clientUid,
      "start",
      "printing_counters"
    );

    if (!sessionActions && computerId && pcConfigStatus !== "new") {
      setSessionStardPending(true);
    }

    if (computerId && pcConfigStatus !== "new") {
      const res = await startSession(
        clientUid,
        computerId,
        "public_computer_session_pending_start"
      );

      if (res && res.result === "success" && !sessionActions) {
        setSessionStatus("started");
        setSessionStardPending(false);
        setSessionActions(true);
        setIsPaused(false);
      }

      console.log("res session", res);
    }

    initialize.current = false;
  };

  const togglePauseSession = async () => {
    if (computerId && pcConfigStatus !== "new") {
      const actionType = isPaused
        ? "public_computer_session_pending_start"
        : "public_computer_session_pause";

      const res = await startSession(clientUid, computerId, actionType);

      if (res && res.result === "success") {
        if (isPaused) {
          // Reprendre la session
          setSessionStatus("started");
          setIsPaused(false);
        } else {
          // Mettre en pause
          setSessionStatus("paused");
          setIsPaused(true);
        }
      }
    }
  };

  const manualStopSession = async () => {
    if (computerId && pcConfigStatus !== "new") {
      setSessionStardPending(true);
      const res = await startSession(
        clientUid,
        computerId,
        "public_computer_session_stop"
      );

      if (res && res.result === "success") {
        setSessionStardPending(false);
        setSessionStatus("ended");
        setSessionActions(false);
        setIsPaused(false);
      }
    }
  };

  const toggleKioskMode = async () => {
    if (computerId) {
      const url = process.env.REACT_APP_SIMPLY_KIOSK_URL;

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            action: "public_computer_update_kiosk",
            userUid: clientUid,
            macAdress: computerId,
            updateData: {
              kiosk: !modeKiosk,
            },
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        // Ne pas mettre à jour localement; l'UI se synchronise via onSnapshot Firestore
      } catch (error) {
        console.error("Erreur lors de la mise à jour du mode kiosk:", error);
      }
    }
  };

  // fonction executee qd on clique sur stop
  const updateFirebase_stop = async () => {
    if (debug === "true")
      console.log("Printer ", id, " - stop(début) - ", Date.now());

    setSpinner(true);

    await setAction(
      nom,
      id,
      ip,
      choix_modele,
      clientUid,
      "stop",
      "printing_counters"
    );

    if (pcConfigStatus !== "new") {
      if (sessionActions) {
        setSessionStardPending(true);
        setSessionStatus("ended");
      }
    }

    if (computerId && pcConfigStatus !== "new") {
      const res = await startSession(
        clientUid,
        computerId,
        "public_computer_session_stop"
      );

      if (res && res.result === "success" && sessionActions) {
        setSessionStardPending(false);
        setSessionActions(false);
      }

      console.log("res session", res);
    }

    initialize.current = false;
    // setAfficherAddData(false); //FIX DU ADDITIONNAL_DATA QUI NE S'AFFICHE PAS QUAND ON CLIQUE SUR LE BOUTON STOP
    // setAfficherErreur(false); // FIX 12/2023 : on ferme l'erreur seulement si user clique sur 'fermer' (voir fermerErreurs)
    // setAfficherReleve(false);
  };

  // fonction executee qd on clique sur info
  const updateFirebase_info = async () => {
    console.log("Printer ", id, " - info(début) - ", Date.now());

    await setAction(
      nom,
      id,
      ip,
      choix_modele,
      clientUid,
      "info",
      "printing_counters"
    );
    initialize.current = false;
    setSpinner2(true);
    // FIX 12/2023 : on ferme l'erreur seulement si user clique sur 'fermer' (voir fermerErreurs)
    // setAfficherAddData(false);
    // setAfficherErreur(false);
  };

  // a chaque chgt ds firestore ce useeffect se produit
  useEffect(() => {
    const unsubscribe = listenResult(id, clientUid, (results) => {
      // console.log('resultat de ecoute sur firestore', results)
      initialize.current = false; // MODIF ANTOINE : permet d'éviter le problème de syncro entre le résultat de l'initialisation et le résultat de l'écoute
      // useref initialize l 132 permet de controler que setResultOnReactApp ne s'execute pas a l'initialisation eviter un rerender ms pb de synchronisation donc on laisse le rerender se faire.
      //j'ai remonte initialize l 123
      if (results && results.length > 0 && initialize.current === false) {
        setResultOnReactApp(results);
      }
      // initialize.current= false
    });

    return unsubscribe;
  }, []);

  // TODO : à supprimer, ne sert juste pour forcer une erreur pour TEST
  // IMPORTANT : remplacer resultOnReactApp par ErrorTEST dans la fonctione useEffect ci-dessous pour TEST
  const modifiedResultOnReactApp = [...resultOnReactApp]; // Clone the array
  modifiedResultOnReactApp[0] = { ...modifiedResultOnReactApp[0] }; // Clone the object

  // Modify the error_statut to "yes"
  modifiedResultOnReactApp[0].result_net = {
    ...modifiedResultOnReactApp[0].result_net,
    error_statut: "yes",
  };
  /* modifiedResultOnReactApp[0].result_useful = {
    ...modifiedResultOnReactApp[0].result_useful,
    error_statut: "yes",
  }; */

  const ErrorTEST = modifiedResultOnReactApp[0];

  // FIN TODO

  useEffect(() => {
    // console.log('resultOnReactApp', resultOnReactApp)

    if (
      resultOnReactApp &&
      resultOnReactApp.length > 0 &&
      resultOnReactApp[0].status === "done"
    ) {
      // On fais passer l'id du copieur à Home pour que si on clique sur 'fermer' on cache et efface dans Firestore le relevé ou les erreurs
      handleCopieurId(id);

      // console.log('Le status du resultat de ecoute sur firestore est à DONE, on met à jour le state avec les données récupérées')

      if (resultOnReactApp[0].type === "info") {
        // setType(resultOnReactApp[0].type) // On force le type à "info" pour afficher le relevé d'info
        setResultOnReactApp(resultOnReactApp);
        handleResultReleve(
          resultOnReactApp,
          resultOnReactApp[0]?.result_net?.error_statut
        );
        setSpinner2(false);
      }

      if (
        resultOnReactApp[0]?.result_net?.error_statut === "no" &&
        resultOnReactApp[0]?.result_net?.data &&
        resultOnReactApp[0]?.result_net?.data !== null
      ) {
        // effacer message erreur précédent (s'il existe)
        handleResultStart(null, "no");

        // START
        if (resultOnReactApp[0]?.type === "start") {
          setResultDebut(resultOnReactApp[0]?.result_net?.data?.DateStart);
        }

        // STOP
        if (resultOnReactApp[0]?.type === "stop") {
          if (
            resultOnReactApp[0]?.result_net?.data?.TotalCouleurRealise &&
            resultOnReactApp[0]?.result_net?.data?.TotalCouleurRealise !== ""
          ) {
            // console.log('will - Stop');
            // console.log('will - Stop TotalCouleurRealise - ', resultOnReactApp[0].result_net.data.TotalCouleurRealise)

            setResultCouleur(
              resultOnReactApp[0]?.result_net?.data?.TotalCouleurRealise
            );
            setResultNb(resultOnReactApp[0]?.result_net?.data?.TotalNbRealise);
            setResultScan(
              resultOnReactApp[0]?.result_net?.data?.TotalScanRealise
            );
            setResultDuree(resultOnReactApp[0]?.result_net?.data?.Duree);
            setResultDebut(resultOnReactApp[0]?.result_net?.data?.DateStart);
            setResultFin(resultOnReactApp[0]?.result_net?.data?.DateEnd);
          } else {
            console.log("will - ERREUR SUR LE STOP CAR VALEURS VIDES");
          }

          // Si données additionnelles
          if (
            resultOnReactApp[0]?.type === "stop" &&
            resultOnReactApp[0]?.result_net?.data?.additional_data &&
            resultOnReactApp[0]?.result_net?.data?.additional_data !== null
          ) {
            console.log("will - Stop avec additional_data");
            setResultOnReactApp(resultOnReactApp);
            handleAdditionalData(
              resultOnReactApp[0]?.result_net?.data?.additional_data,
              nom
            );
          }
        }

        setSpinner(false);

        if (resultOnReactApp[0]?.printer_status === "busy") {
          setEtatLibre(false);
          setResultEtat(false);
        } else if (resultOnReactApp[0]?.printer_status === "free") {
          setEtatLibre(true);
          setResultEtat(true);
        }

        // Si erreur de notification
        if (
          resultOnReactApp[0]?.result_net?.data?.notification &&
          resultOnReactApp[0]?.result_net?.data?.notification !== null &&
          Object.keys(resultOnReactApp[0]?.result_net?.data?.notification)
            .length !== 0
        ) {
          handleResultStart(resultOnReactApp, "yes");
          setResultCouleur(null);
          setResultNb(null);
          setResultScan(null);
          setResultDuree("");
          setResultDebut("");
          setResultFin("");
          setSpinner(false);
          if (resultOnReactApp[0]?.printer_status === "busy") {
            setEtatLibre(false);
            setResultEtat(false);
          } else if (resultOnReactApp[0]?.printer_status === "free") {
            setEtatLibre(true);
            setResultEtat(true);
          }
        }
      } else if (resultOnReactApp[0]?.result_net?.error_statut === "yes") {
        console.log("DEBUG : ERREUR_STATUT = YES");
        handleResultStart(
          resultOnReactApp,
          resultOnReactApp[0]?.result_net?.error_statut
        );
        setResultCouleur(null);
        setResultNb(null);
        setResultScan(null);
        setResultDuree("");
        setResultDebut("");
        setResultFin("");
        setSpinner(false);
        if (resultOnReactApp[0]?.printer_status === "busy") {
          setEtatLibre(false);
          setResultEtat(false);
        } else if (resultOnReactApp[0]?.printer_status === "free") {
          setEtatLibre(true);
          setResultEtat(true);
        }
      } else {
        //console.log("nothing")
      }

      if (debug === "true") {
        console.log(
          "Printer ",
          id,
          " - ",
          resultOnReactApp[0]?.type,
          "(fin) - ",
          Date.now()
        );
        console.log("Données Firestore traitées : ", resultOnReactApp);
      }
    }
    // else{
    //   console.log('Le status du resultat de ecoute sur firestore est à TODO, on ne fait rien')
    // }
  }, [resultOnReactApp]);

  // erreur si au bout de 10 secondes statut_processing toujours a todo, signifie pas de connexion user à electron
  useEffect(() => {
    let timer1;

    if (spinner || spinner2) {
      // console.log("ID du copieur", id)
      // console.log("resultOnReactApp", resultOnReactApp)
      timer1 = setTimeout(() => {
        console.log(
          "check if status is 'done' before 10sec: status = ",
          resultOnReactApp[0]?.status
        );
        if (
          resultOnReactApp[0]?.status &&
          resultOnReactApp[0]?.status === "todo"
        ) {
          setSpinner(false);
          setSpinner2(false);
          console.log("electron not connected");
          handleErrorElectron(nom);
        }
      }, 10000);
      return () => {
        clearTimeout(timer1);
      };
    }
  }, [spinner, spinner2]);

  if (resultOnReactApp === null) return null;

  return (
    <>
      <div className="infoBox">
        <button
          className="historique"
          onClick={() =>
            window.open(
              `https://www.simply-copy.com/printer-view.php?view=history&printer=${id}&a=${encodeURIComponent(currentUser.encrypted_a)}&b=${encodeURIComponent(currentUser.encrypted_b)}`
            )
          }
        >
          <img
            src={historiqueLogo}
            className="historiqueLogo"
            alt="historiqueLogo"
          ></img>
          <h3>{t("start1.history")}</h3>
        </button>
        {!copieurActivated ? (
          <div className="copieurDesactive divOccupe backg">
            <span>{t("start1.disabled")}</span>
          </div>
        ) : (
          <div className={`divOccupe ${resultEtat ? "backv" : "backr"}`}>
            <span>{resultEtat ? t("start1.free") : t("start1.busy")}</span>
          </div>
        )}
        {spinner2 ? (
          <div className="details">
            <PuffLoader
              color={"crimson"}
              loading={true}
              css={override}
              size={25}
            />
          </div>
        ) : (
          <button
            className="details"
            onClick={updateFirebase_info}
            disabled={resultEtat}
          >
            <img src={infoLogo} className="infoLogo" alt="infoLogo"></img>
            <h3>{t("start1.statement")}</h3>
          </button>
        )}
      </div>

      <div className="nbStat">
        <div className="nbColonne">
          <div
            className={`${copieurActivated ? "square" : "squareDesactivated"}`}
          >
            <h2 className="squareNumber">{!etatLibre ? "" : resultNb}</h2>
          </div>
          <h3 className="nbStatType">{t("start1.black&white")}</h3>
        </div>
        <div className="nbColonne">
          <div
            className={`${copieurActivated ? "square" : "squareDesactivated"}`}
          >
            <h2 className="squareNumber">{!etatLibre ? "" : resultCouleur}</h2>
          </div>
          <h3 className="nbStatType">{t("start1.colors")}</h3>
        </div>
        <div className="nbColonne">
          <div
            className={`${copieurActivated ? "square" : "squareDesactivated"}`}
          >
            <h2 className="squareNumber">{!etatLibre ? "" : resultScan}</h2>
          </div>
          <h3 className="nbStatType">{t("start1.scan")}</h3>
        </div>
      </div>

      <div className="timeZone">
        {resultEtat ? (
          <>
            <div className="timeItem">
              <span>
                {t("start1.start")}:{" "}
                <strong>{formatDateWithTimezone(resultDebut)}</strong>
              </span>
            </div>
            <div className="timeItem">
              <span>
                {t("start1.end")}:{" "}
                <strong>{formatDateWithTimezone(resultFin)}</strong>
              </span>
            </div>
            <div className="timeItem">
              <span>
                {t("start1.time")}: <strong>{resultDuree}</strong>
              </span>
            </div>
          </>
        ) : (
          <span>
            {t("start1.start")}:{" "}
            <strong>{formatDateWithTimezone(resultDebut)}</strong>
          </span>
        )}
      </div>

      <div>
        {spinner ? (
          <div className="sweet-loading">
            <PuffLoader
              color={"crimson"}
              loading={true}
              css={override}
              size={65}
            />
          </div>
        ) : (
          <>
            {!copieurActivated ? (
              <div className="copieurDesactive">
                <button className="desactiveCircle" disabled={true}>
                  <FaPlay className="startButton" />
                </button>
              </div>
            ) : (
              <>
                {
                  //resultatEtat true libre donc bouton start
                  resultEtat ? (
                    <button
                      className="startCircle"
                      onClick={updateFirebase_start}
                    >
                      <FaPlay className="startButton" />
                    </button>
                  ) : (
                    <button className="stop" onClick={updateFirebase_stop}>
                      <FaStopCircle className="startButton" />
                    </button>
                  )
                }
              </>
            )}
          </>
        )}
      </div>

      {computerId && (
        <div className="timeZone">
          {pcStatus || pcConfigStatus ? (
            <small>
              Statut PC :{" "}
              {pcConfigStatus === "new" ? (
                <span style={{ color: "red" }}>Non configuré</span>
              ) : (
                <span
                  style={{ color: pcStatus === "online" ? "green" : "red" }}
                >
                  {pcStatus === "online" ? "En ligne" : "Hors ligne"}
                </span>
              )}
            </small>
          ) : (
            <div className="pcDisconnected">
              <div className="redDot" />
              <small>PC déconnecté</small>
            </div>
          )}
          <div className="flexCol">
            {foundItem && pcStatus !== "offline" && (
              <small>Affichage : {modeKiosk ? "Plein écran" : "Fenêtre"}</small>
            )}
            {foundItem && pcStatus !== "offline" && (
              <small>
                Session:{" "}
                <span
                  style={{
                    color:
                      sessionStatus === "started"
                        ? "green"
                        : sessionStatus === "paused"
                        ? "orange"
                        : sessionStatus === "ended"
                        ? "red"
                        : sessionStatus === "pending_start"
                        ? "orange"
                        : sessionStatus === "error"
                        ? "red"
                        : "inherit",
                  }}
                >
                  {{
                    started: "En cours",
                    paused: "En pause",
                    ended: "Terminée",
                    pending_start: "En attente de démarrage",
                    error: "Erreur",
                  }[sessionStatus] || sessionStatus}
                </span>
              </small>
            )}
          </div>
          {pcStatus !== "offline" && (
            <div className="timeZoneActions">
              <div className="copieurActions">
                <h5>Action disponibles</h5>
                <button
                  className="collapseButton"
                  onClick={() => setIsCollapsed(!isCollapsed)}
                >
                  {isCollapsed ? <FaChevronUp /> : <FaChevronDown />}
                </button>
              </div>

              {isCollapsed && (
                <Collapse isOpened={isCollapsed}>
                  {sessionStartPending && (
                    <div className="sweet-loading">
                      <PuffLoader
                        color={"crimson"}
                        loading={true}
                        css={override}
                        size={35}
                      />
                    </div>
                  )}
                  {pcConfigStatus !== "new" && (
                    <div>
                      <button className="sessionBtn" onClick={toggleKioskMode}>
                        {modeKiosk
                          ? "Désactiver le mode kiosk"
                          : "Activer le mode kiosk"}
                      </button>
                      <button
                        className="sessionBtn"
                        onClick={() => setShowSessionModal(true)}
                      >
                        Détails de la session
                      </button>
                      {sessionActions && (
                        <>
                          <button
                            className="sessionBtn"
                            onClick={togglePauseSession}
                          >
                            {isPaused
                              ? "Reprendre la session"
                              : "Mettre en pause"}
                          </button>
                          <button
                            className="sessionBtn"
                            onClick={manualStopSession}
                          >
                            Arrêter la session
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </Collapse>
              )}
            </div>
          )}
        </div>
      )}

      {resultEtat && userClientType === "BV" ? (
        <div className="copieurInformation">
          <button
            onClick={() =>
              window.open(
                `https://bv.elyote.com/espace-services.php?cart_type=releve&print_black=${resultNb}&print_color=${resultCouleur}&scan=${resultScan}&type_service=${usageDefault}`
              )
            }
          >
            {t("start1.send_to_elyote")}
          </button>
        </div>
      ) : (
        <div></div>
      )}

      <SessionDetailsModal
        isOpen={showSessionModal}
        onClose={() => setShowSessionModal(false)}
        clientUid={clientUid}
        computerId={computerId}
      />
    </>
  );
}

export default Start1;
